module.exports = __webpack_public_path__ + "media/images/edit-0815d0c406caea394d486870950ca0bf.png";